module.exports = __webpack_public_path__ + "static/media/custom-offer3@2x.74030b39.png";